import { CloseIcon } from '@/components/common/icon';
import WebModal from '@/components/web/components/Modal';
import { isMobile } from '@/biz/tool';
import { useWebModalStore } from '@/hooks/useWebModalStore';
const ModalShowImage = () => {
  const { showModalShowImage, modalImageUrl, setShowModalShowImage } =
    useWebModalStore();

  const AudienceInsightsImage = ({ onClose }: { onClose: () => void }) => {
    return (
      <div className="relative" onClick={onClose}>
        <div className="absolute -top-12 right-2 rounded-full p-2 cursor-pointer hover:bg-gray-200">
          <CloseIcon className="w-6 h-6" onClick={onClose} />
        </div>
        <img
          alt="audience-insights"
          src={modalImageUrl}
          className=""
          style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain' }}
          onLoad={(e) => {
            const { width, height } = e.target as HTMLImageElement;
            console.log('width', width);
            console.log('height', height);
            // 宽的则宽度90%，高的则高度90%
            if (width > height) {
              (e.target as HTMLImageElement).style.width = '90vw';
              (e.target as HTMLImageElement).style.height = 'auto';
            } else {
              (e.target as HTMLImageElement).style.height = '90vh';
              (e.target as HTMLImageElement).style.width = 'auto';
            }
          }}
        />
      </div>
    );
  };

  return (
    <WebModal
      visible={showModalShowImage}
      canClose={true}
      handleClose={() => setShowModalShowImage(false)}
      isShowFooter={false}
      isShowHeader={false}
      width={isMobile() ? 375 : undefined}
      style={{
        width: isMobile() ? '375px' : '1000px',
        height: 'auto',
        maxWidth: '90%',
        maxHeight: '90%',
        background: 'transparent'
      }}
      className={`!z-[99999999]
        ${isMobile() ? 'p-0' : 'p-0'}
        `}
    >
      <AudienceInsightsImage onClose={() => setShowModalShowImage(false)} />
    </WebModal>
  );
};

export default ModalShowImage;
